import { render, staticRenderFns } from "./KnowledgeContent.vue?vue&type=template&id=1696d9cf&"
import script from "./KnowledgeContent.vue?vue&type=script&lang=js&"
export * from "./KnowledgeContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports